module.exports = __webpack_public_path__ + "static/media/cl_logo.baba75f7.webp";